import { getOriginalResource } from "PFApp/booking/parts/helpers";
import { Row } from "PFApp/booking/types";
import { CalendarRoot } from "PFApp/booking/types/calendar_root";
import { ProfileBasic, WorkforceItemResource } from "PFApp/booking/types/row";

import { findClosestProfileRow } from "./find_closest_profile_row";

type IsDroppableTarget = {
  targetRow: Row;
  sourceRow: Row;
  rowsByKey: Record<string, Row>;
  calendarRoot: CalendarRoot;
};

export const checkIsSourceRow = (targetRow: Row, sourceRow: Row, rowsByKey: Record<string, Row>): boolean => {
  const targetProfileRow = findClosestProfileRow({ row: targetRow, rowsByKey });
  const sourceProfileRow = findClosestProfileRow({ row: sourceRow, rowsByKey });

  if (!targetProfileRow || !sourceProfileRow) {
    return false;
  }

  return targetProfileRow.original.id === sourceProfileRow.original.id;
};

export const isDroppableTarget = ({
  targetRow,
  sourceRow,
  rowsByKey,
  calendarRoot
}: IsDroppableTarget): boolean => {
  const isSourceRow = checkIsSourceRow(targetRow, sourceRow, rowsByKey);
  if (isSourceRow) {
    return false;
  }

  const targetRowProfile = getOriginalResource(targetRow, calendarRoot) as
    | WorkforceItemResource
    | ProfileBasic
    | null;

  return !targetRowProfile?.suspendedAt;
};
